module.exports = __webpack_public_path__ + "img/unsubscribed.bfe894a7.png";